@if (!isSvg && !isLogo && !isImage) {
  <mat-icon [class]="_icon" [style.color]="modifyColor">{{ _icon }}</mat-icon>
}
@if (isSvg) {
  <mat-icon [svgIcon]="_icon" [style.color]="color" class="criteria-icon tb-icon" style="font-size: 24px"></mat-icon>
}
@if (isLogo) {
  <img src="assets/img/productRecommendations/{{ _icon }}.svg" class="product-recommendation {{ logoType }}" [ngClass]="{ disabled: isLogoDisabled }" />
}
@if (isImage) {
  <img [ngClass]="{ disabled: isLogoDisabled }" class="is-image" src="assets/img/icons/{{ _icon }}" alt="" />
}
